import React, { Component } from 'react';
import { animateScroll as scroll } from 'react-scroll';
import { connect } from 'react-redux';


import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import SideDrawer from '../../components/Navigation/SideDrawer/SideDrawer';
import StickyToTopButton from '../../components/UI/Buttons/StickyToTopButton/StickyToTopButton';

import classes from './Layout.css';

class Layout extends Component {

    state = {
        showSideDrawer: false
    }

    // componentWillUpdate() {
    //     this.setState({ showSideDrawer: false})
    // }


    sideDrawerOpenHandler = () => {
        this.disableScroll()
        this.setState({ showSideDrawer: true})
        
    }

    sideDrawerClosedHandler = () => {
        this.enableScroll()
        this.setState({ showSideDrawer: false})
    }

    toTopHandler = () => {
        // window.scrollTo(0,0)
        scroll.scrollToTop();
    }

    disableScroll = () => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop
        const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft

        window.onscroll = () => {
            window.scrollTo(scrollLeft, scrollTop)
        }
    }

    enableScroll = () => {
        window.onscroll = () => {}
    }



    render() {
        return (
            <div className={classes.Wrapper}>
                <Header 
                    open={this.sideDrawerOpenHandler}/>
                <StickyToTopButton clicked={this.toTopHandler}/>
                <SideDrawer 
                    open={this.state.showSideDrawer}
                    closed={this.sideDrawerClosedHandler}
                    isAuth={this.props.isAuthenticated}/>
                
                <div className={classes.Layout}>
                    {this.props.children}
                </div>
              
                <Footer />
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        isAuthenticated: state.token !== null
    }
}

export default connect(mapStateToProps)(Layout);


// WEBPACK FOOTER //
// ./src/containers/Layout/Layout.js